import { useState, useEffect } from "react";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPatch } from "../../../api";

import MDPopup from "../../../components/MDPopup";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import MDSelect from "../../../components/MDSelect";


const Page = (props) => {
	const { user } = useAuthContext();

	const ticket = props.ticket;

	const [note, setNote] = useState(0);
	const [validSubmit, setValidSubmit] = useState(false);

	useEffect(() => {
		setValidSubmit(!!note && note > 0 && note < 6);
	}, [note])

	useEffect(() => {
		setNote(0)
		setValidSubmit(false)
	}, [props.open])

	const handleSubmit = async () => {
		const response = await httpPatch(process.env.REACT_APP_URL_BASE+`/ticket/note`, {
              note: parseInt(note),
              ticket_id: ticket
            })

		if (response.status !== 201){
            alert("Something went wrong");
            console.log(response);
            return
        }

        props.setRefreshed(true);
        props.close();
	}


	return <>
		<MDPopup display="flex" flexDirection="column" justifyContent="center" alignItems="center" open={props.open}>
	        <MDTypography variant="h3" color="info" textAlign="center" fontWeight="bold">Share Your Feedback</MDTypography>

	        <br />

	        <MDTypography variant="h5" color="dark" textAlign="center" fontWeight="bold">We’d love to hear about your experience with our customer service.<br />Please leave a note about your ticket—your feedback helps us improve!</MDTypography>

	        <br />
	        <MDBox width="70%">
	          <MDTypography variant="h6" color="text">How much were you satisfied with our customer service ?</MDTypography>
	          <MDSelect onChange={(e) => setNote(e.target.value)} label="Your feedback" menu={[
	          	{ value: "1", label: "Very Dissatisfied" },
	          	{ value: "2", label: "Dissatisfied" },
	          	{ value: "3", label: "Neutral" },
	          	{ value: "4", label: "Satisfied" },
	          	{ value: "5", label: "Very Satisfied" }
	          	]} />
	        </MDBox>

	        <br />

	        <MDBox width="70%" textAlign="center">
	          <MDButton onClick={handleSubmit} disabled={!validSubmit} variant="text" color="success">Evaluate</MDButton>
	          <MDButton variant="outlined" color="error" onClick={props.close}>Cancel</MDButton>
	        </MDBox>
	    </MDPopup>
	</>
}

export default Page